// Remove trailing / if present
export function getCurrentPath() {
  const {pathname} = window.location;
  return pathname.length > 1 && pathname.substring(pathname.length - 1) === '/' ? pathname.slice(0, -1) : pathname;
}
